import React from 'react';
import cn from 'classnames';

import { useTheme } from 'providers/Theme.provider';

import CN from './SectionSeparator.module.scss';

const SectionSeparator = () => {
  const { isDarkMode } = useTheme();

  return (
    <div
      className={cn({
        [CN.component]: true,
        [CN.darkMode]: isDarkMode,
      })}
    />
  );
};

export default SectionSeparator;
